import { render, staticRenderFns } from "./Typhoon50.vue?vue&type=template&id=27ffa242"
import script from "./Typhoon50.vue?vue&type=script&lang=js"
export * from "./Typhoon50.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports